import { RepositoryFactory } from '@/Repository/RepositoryFactory'
const BookingRepository = RepositoryFactory.get('booking_repository')

const state = {
    courses: [],
    members: null,
    redirectUrl: null,
    transactionId: null,
    paymentStatus: null,
}

const getters = {
    getCourses: state => state.courses,
    getMemberCount: state => state.members,
    getRedirectUrl: state => state.redirectUrl,
    getTransactionId: state => state.transactionId,
    getPaymentStatus: state => state.paymentStatus
}

const actions = {
    // Fetch Courses
    async fetchCourses({commit}) {
        try {
            commit('setCourses', [])
            const resp = await BookingRepository.fetchCourses();
            if(resp.data.success) {
                commit('setCourses', resp.data.courses)
                return 1
            }
            else {
                commit("setToast", {message: resp.data.message, title: "Courses List", type: "danger"})
                return 0
            }
        }
        catch(err) {
            commit("setToast", {message: err.message, title: "Courses List", type: "danger"})
            return 0
        }
    },

    // Get Courses With Enrolled Count
    async getCoursesWithEnrolledCount({commit}) {
        try {
            commit('setCourses', [])
            const resp = await BookingRepository.getCoursesWithEnrolledCount();
            if(resp.data.success) {
                commit('setCourses', resp.data.courses)
                return 1
            }
            else {
                commit("setToast", {message: resp.data.message, title: "Courses List", type: "danger"})
                return 0
            }
        }
        catch(err) {
            commit("setToast", {message: err.message, title: "Courses List", type: "danger"})
            return 0
        }
    },

    // Fetch Members Count
    async getTotalMembers({commit}, payload) {
        try {
            commit('setCourses', [])
            const resp = await BookingRepository.getTotalMembers(payload);
            if(resp.data.status) {
                commit('setCount', resp.data.members)
                return 1
            }
            else {
                commit("setToast", {message: resp.data.message, title: "Members List", type: "danger"})
                return 0
            }
        }
        catch(err) {
            var error_message = err.message
            if ((err.response) && (err.response.data)) {
                error_message = err.response.data.message
            }
            commit("setToast", {message: error_message, title: "Members List", type: "danger"})
            return 0
        }
    },

    // Create Corporate Booking
    async createCorporateBooking({commit}, payload) {
        try {
            const resp = await BookingRepository.createCorporateBooking(payload)
            if(resp.data.status) {
                commit("setToast", {message: "Booking Created Successfully", title: "Create Bookings", type: "success"})
                return 1
            }
            else {
                commit("setToast", {message: "Something went wrong.", title: "Create Bookings", type: "danger"})
                return 0
            }
        }
        catch(err) {
            var error_message = err.message
            if ((err.response) && (err.response.data)) {
                error_message = err.response.data.message
            }
            commit("setToast", {message: error_message, title: "Create Bookings", type: "danger"})
            return 0
        }
    },

    // Create Member Booking
    async createMemberBooking({commit} , payload) {
        try {
            const resp = await BookingRepository.createMemberBooking(payload)
            if(resp.data.status) {
                commit('setRedirectUrl', resp.data);
                commit('setTransactionId', resp.data);
                commit("setToast", {message: "Booking Created Successfully", title: "Create Booking", type: "success"})
                return 1
            }
            else {
                commit("setToast", {message: "Something went wrong.", title: "Create Booking", type: "danger"})
                return 0
            }
        }
        catch(err) {
            var error_message = err.message
            if ((err.response) && (err.response.data)) {
                error_message = err.response.data.message
            }
            commit("setToast", {message: error_message, title: "Create Booking", type: "danger"})
            return 0
        }
    },

    // Check Alipay Payment
   async checkAlipayPayment({commit} , payload) {
        try {
            const resp = await BookingRepository.checkAlipayPayment(payload)
            if(resp.data.status) {
                commit('setPaymentStatus', resp.data);
                return 1
            }
            else {
                commit("setToast", {message: "Something went wrong.", title: "Check Alipay Payment", type: "danger"})
                return 0
            }
        }
        catch(err) {
            var error_message = err.message
            if ((err.response) && (err.response.data)) {
                error_message = err.response.data.message
            }
            commit("setToast", {message: error_message, title: "Check Alipay Payment", type: "danger"})
            return 0
        }
    }

    
}

const mutations = {
    setCourses: (state, payload) => {
        let courseArray = []
        payload.forEach(item => {
            if(!item.isDeleted) {
                courseArray.push(item)
            }
        })
        state.courses = courseArray
    },

    setRedirectUrl: (state, payload) => {
        state.redirectUrl = payload.redirectUrl ? payload.redirectUrl : null;
    },

    setTransactionId: (state, payload) => {
        state.transactionId = payload.transactionId ? payload.transactionId : null;
    },

    setPaymentStatus: (state, payload) => {
        state.paymentStatus = payload;
    },

    setCount: (state, payload) => state.members = payload
}

export default {
    state,
    getters,
    actions,
    mutations
}